import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import Modal from "react-modal";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { initRum } from "./observability/rum";
import ErrorBoundary from "./observability/ErrorBoundary";
import RumRouteTracker from "./observability/RumRouteTracker";
import { APP_VERSION, GIT_SHA } from "./config/env";

// Build stamp injected by the deploy workflows (see GIT_WORKFLOW.md → Versioning);
// values are absent in local dev.
console.info(
  `myhealthvaults-frontend ${APP_VERSION || "dev"} ` +
    `(${(GIT_SHA || "local").slice(0, 8)})`
);

// CloudWatch RUM (no-op unless the app monitor env vars are baked in).
// See root FRONTEND_RUM_SETUP.md.
initRum();

const root = ReactDOM.createRoot(document.getElementById("root"));
Modal.setAppElement("#root");
root.render(
  <ErrorBoundary>
    <BrowserRouter>
      <RumRouteTracker />
      <App />
    </BrowserRouter>
  </ErrorBoundary>
);

serviceWorkerRegistration.register();
